import { Actions, type InventoryListReducerState } from '@openx/types/inventoryList';
import { getInitialData } from './getInitialData';
import type { Action } from './types';

export const reducerInventoryList = (state: InventoryListReducerState, action: Action): InventoryListReducerState => {
  switch (action.type) {
    case Actions.SET_BULK_INPUT:
      return { ...state, bulkInput: action.payload };
    case Actions.SET_LIST_DATA:
      return { ...state, listData: action.payload };
    case Actions.RESET_FORM:
      return getInitialData([]);
    case Actions.VALIDATE:
      return {
        ...state,
        bulkErrors: action.payload?.errors || [],
        validItems: action.payload?.validItems || [],
        textareaDisabled: true,
        bulkInput: action.payload?.validItems?.join('\n') ?? '',
      };
    case Actions.CLOSE_ERROR:
      return { ...state, bulkErrors: [], textareaDisabled: false };
    case Actions.ADD_ITEMS:
      return {
        ...state,
        listData: [...state.listData, ...action.payload],
        bulkInput: '',
        bulkErrors: [],
        validItems: [],
        textareaDisabled: false,
      };

    default:
      return state;
  }
};
